import React from 'react';
import { useToast } from '../../contexts/ToastContext';
import './Common.css';

const Toast = () => {
    const { toast, hideToast } = useToast();

    if (!toast.show) return null;

    const getIcon = () => {
        switch (toast.type) {
            case 'success': return 'fa-check-circle';
            case 'error': return 'fa-exclamation-circle';
            case 'warning': return 'fa-exclamation-triangle';
            default: return 'fa-info-circle';
        }
    };

    return (
        <div className={`toast ${toast.type}`} onClick={hideToast}>
            <i className={`fas ${getIcon()}`}></i>
            <span>{toast.message}</span>
        </div>
    );
};

export default Toast;
